import { UserService } from "./userService";
import { AxiosResponse } from 'axios';
import { UserRightsChanged } from "../../types/user";

export interface ApiUsers {
    getLicenseDataAndUsers(urlParams: string): Promise<AxiosResponse>;
    updateUsers(data: UserRightsChanged[]): Promise<AxiosResponse>;
}

export const userService = new UserService();